import skipItemFromUpcomingOngoingTreatment from './skipItemFromUpcomingOngoingTreatment';
import { AgendaItem, OnAgendaItemUpdate } from 'mini-agenda';

export const defaultPropertyUpdater: OnAgendaItemUpdate = (
    item: AgendaItem,
    property: keyof AgendaItem,
    newValue: any
) => {
    item[property] = newValue as never; // Cast it to the most basic type - defaultPropertyUpdater
};

/**
 * Assings the timer to the event card. Call this function from mutators if the passed item object is a part of the store
 * @param item
 * @param isUpcomingEventItem this determines if the item is upcoming or not ( We could have used the store to access this, but that will not cause re-render for the item)
 */
export function setIsActiveTimerForItem(
    item: AgendaItem,
    isUpcomingEventItem: boolean = false,
    onItemUpdate: OnAgendaItemUpdate = defaultPropertyUpdater
) {
    clearIsActiveTimer(item);

    if (skipItemFromUpcomingOngoingTreatment(item)) {
        return;
    }

    const { IsOngoingEvent } = item.event;
    const isEventUpcoming = isUpcomingEventItem;

    if (isEventUpcoming || IsOngoingEvent) {
        setExpirationTimer(item, onItemUpdate);
    } else if (item.isActive) {
        // this is an event which occured in the past or which was initially upcoming but no longer upcoming
        onItemUpdate && onItemUpdate(item, 'isActive', false);
        clearIsActiveTimer(item);
    }
}

export function clearIsActiveTimer(
    item: AgendaItem,
    onItemUpdate: OnAgendaItemUpdate = defaultPropertyUpdater
) {
    if (item.timer) {
        clearTimeout(item.timer);
        onItemUpdate && onItemUpdate(item, 'timer', undefined);
    }
}

function setExpirationTimer(item: AgendaItem, onItemUpdate: OnAgendaItemUpdate) {
    // This sets a timer which keeps waiting to make an active event inactive based on the time remaining from the current time ( component mounting time ) to the first moment
    // when the event completes
    // By the fundamental law of nature time  never moves backward, each event can be marked active utmost once, based on its expiration time
    // This sets a timer which keeps waiting to make an active event inactive based on the time remaining from the current time ( component mounting time ) to the first moment
    // when the event completes
    // By the fundamental law of nature time  never moves backward, each event can be marked active utmost once, based on its expiration time
    !item.isActive && onItemUpdate && onItemUpdate(item, 'isActive', true);

    if (!item.timer) {
        const { event } = item;
        onItemUpdate(
            item,
            'timer',
            setTimeout(() => {
                clearIsActiveTimer(item);

                item.isActive && onItemUpdate && onItemUpdate(item, 'isActive', false);
            }, event.RemainingTimeToEventEnd)
        );
    }
}
